import axios from "axios";

export default ({
  baseUrl = "",
  catchMissingAuth,
  getDefaultHeaders = () => ({}),
} = {}) => {
  function promisify(request) {
    function handleError(err) {
      if (!err.response) {
        return;
      }
      if (err.response.status === 401 && catchMissingAuth) {
        catchMissingAuth(err);
      }
      throw err.response.data;
    }

    const promise = request.then((res) => res.data).catch(handleError);

    Object.defineProperties(promise, {
      status: {
        get() {
          return request.then((res) => res.status);
        },
      },
      headers: {
        get() {
          return request.then((res) => res.headers);
        },
      },
    });

    return promise;
  }

  function getOptions(options = {}) {
    const defaultHeaders = getDefaultHeaders();
    return {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...defaultHeaders,
        ...(options.headers || {}),
      },
    };
  }

  return {
    get(url, query, options) {
      const request = axios.get(
        `${baseUrl}/${url}`,
        getOptions({ ...options, params: query }),
      );
      return promisify(request);
    },

    put(url, body, options) {
      const request = axios.put(`${baseUrl}/${url}`, body, getOptions(options));
      return promisify(request);
    },

    post(url, body, options) {
      const request = axios.post(
        `${baseUrl}/${url}`,
        body,
        getOptions(options),
      );
      return promisify(request);
    },

    patch(url, body, options) {
      const request = axios.patch(
        `${baseUrl}/${url}`,
        body,
        getOptions(options),
      );
      return promisify(request);
    },

    delete(url, query = {}, options) {
      const request = axios.delete(
        `${baseUrl}/${url}`,
        getOptions({ ...options, params: query }),
      );
      return promisify(request);
    },
  };
};
